import { handleActions } from "redux-actions";

import {
    clearUsersRoles,
    createRole,
    createRoleError,
    createRoleSuccess,
    getActionsForRole,
    getActionsForRoleError,
    getActionsForRoleSuccess,
    getRoleByID,
    getRoleByIDError,
    getRoleByIDSuccess,
    getUsersRoles,
    getUsersRolesError,
    getUsersRolesSuccess,
    updateRole,
    updateRoleError,
    updateRoleSuccess
} from "./actions";


const initialState = {
    isLoading: false,
    count: 0,
    roles: [],
    roleById: null,
    isLoadingRole: false,
    auth_policy_definitions: [],
    isLoadingPolicyDefinitions: false
};

export const rolesEntriesReducer = handleActions(
    {
        [clearUsersRoles]: () => ({ ...initialState }),

        [getUsersRoles]: (state) => ({
            ...state,
            roles: [],
            isLoading: true
        }),
        [getUsersRolesSuccess]: (state, { payload }) => ({
            ...state,
            ...payload,
            isLoading: false
        }),
        [getUsersRolesError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [createRole]: (state) => ({
            ...state,
            isLoadingRole: true
        }),
        [createRoleSuccess]: (state) => ({
            ...state,
            isLoadingRole: false
        }),
        [createRoleError]: (state) => ({
            ...state,
            isLoadingRole: false
        }),

        [updateRole]: (state) => ({
            ...state,
            isLoadingRole: true
        }),
        [updateRoleSuccess]: (state) => ({
            ...state,
            isLoadingRole: false
        }),
        [updateRoleError]: (state) => ({
            ...state,
            isLoadingRole: false
        }),

        [getRoleByID]: (state) => ({
            ...state,
            roleById: [],
            isLoadingRole: true
        }),
        [getRoleByIDSuccess]: (state, { payload }) => ({
            ...state,
            roleById: payload,
            isLoadingRole: false
        }),
        [getRoleByIDError]: (state) => ({
            ...state,
            isLoadingRole: false
        }),

        [getActionsForRole]: (state) => ({
            ...state,
            auth_policy_definitions: [],
            isLoadingPolicyDefinitions: true
        }),
        [getActionsForRoleSuccess]: (state, { payload }) => ({
            ...state,
            auth_policy_definitions: payload,
            isLoadingPolicyDefinitions: false
        }),
        [getActionsForRoleError]: (state) => ({
            ...state,
            isLoadingPolicyDefinitions: false
        })
    },
    initialState
);
